import { Grid, IconButton, Menu, MenuItem, PaletteMode, Typography } from "@mui/material"
import  MenuIcon  from "@mui/icons-material/Menu";
import { useState, MouseEvent } from "react";
import { useNavigate } from "react-router-dom";
import { VerticalNavbarItem } from "./VerticalNavbar";
import { SettingsOutlined } from "@mui/icons-material";
import { useMobileView } from "../../../Hooks/useMobileView";

interface SettingsHamburgerProps {
    mode: PaletteMode;
    pages: VerticalNavbarItem[]
}

export const SettingsHamburger = ({ mode, pages }: SettingsHamburgerProps) => {
    /* ******************** Hooks ******************** */
    const navigate = useNavigate();
    const { isMobileView } = useMobileView();
    /* ******************** Variables ******************** */
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [menuOpen, setMenuOpen] = useState(false);
    /* ******************** Functions ******************** */
    const handeMenuOpen = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        setMenuOpen(!menuOpen);
    } 
    const handeMenuClose = () => {
        setAnchorEl(null);
        setMenuOpen(false);
    }
    const handleNavClick = (page: VerticalNavbarItem) => {
        if (page.action)
            page.action();
        if (page.link.length > 0)
            navigate(`/${page.link}`);
        handeMenuClose();
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid  item display={"flex"} justifyContent={"flex-end"} alignItems={"center"} flex={isMobileView ? 'none' : 1}>
            <IconButton color="primary" onClick={handeMenuOpen}>
                <SettingsOutlined color="primary" sx={{fontSize: '18px'}}/>
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={handeMenuClose}
            >
                {pages.map((page, idx) => (
                    <MenuItem 
                        key={idx} 
                        onClick={() => handleNavClick(page)} 
                        disabled={page.disabled}
                    >
                        <Typography textAlign="center">{page.label}</Typography>
                    </MenuItem>
                ))}
            </Menu>
        </Grid>
    )
}